import {cn} from "@/lib/utils";
import {getResidentHomeQuotaDisplay} from "@/src/modules/safelistings/lib/format-resident-home-safelistings-quota";
import type {ResidentHomeSafelistingsAccountability} from "@/src/modules/safelistings/types/resident-home-accountability";

type ResidentHomeSafelistingsQuotaSummaryProps = {
  accountability: ResidentHomeSafelistingsAccountability | null;
  isPending?: boolean;
  className?: string;
};

export function ResidentHomeSafelistingsQuotaSummary({
  accountability,
  isPending = false,
  className,
}: ResidentHomeSafelistingsQuotaSummaryProps) {
  if (isPending) {
    return <p className={cn("text-muted-foreground text-sm", className)}>Loading usage…</p>;
  }

  const display = getResidentHomeQuotaDisplay(accountability);
  if (!display) return null;

  return (
    <div className={cn("flex min-w-0 flex-col gap-0.5", className)}>
      <p className="text-muted-foreground text-pretty text-xs leading-snug">{display.primaryLine}</p>
      {display.secondaryLine ? (
        <p
          className={cn(
            "text-sm leading-snug font-medium tabular-nums",
            display.isQuotaExhausted && display.quotaActionable && "text-destructive",
            !display.isQuotaExhausted && "text-foreground",
          )}
        >
          {display.secondaryLine}
        </p>
      ) : null}
    </div>
  );
}
